import { AutoSizeTextarea, Input } from '@/components';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styles from './index.module.scss';
import { urlRegex } from '../../utils';
import { ErrorMessage } from '@hookform/error-message';

export const CommonField = ({ hideLink }: { hideLink?: boolean }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <>
      {!hideLink ? (
        <div className={styles.formItem}>
          <div className={styles.labelContainer}>
            <div className={styles.label}>Related link</div>
          </div>
          <Controller
            control={control}
            name="data.related_link"
            render={({ field, fieldState }) => (
              <Input
                className={styles.input}
                placeholder="Please paste the link the users cloud interact"
                value={field?.value}
                onChange={field?.onChange}
                error={!!fieldState.error}
              />
            )}
            rules={{
              required: true,
              pattern: {
                value: urlRegex,
                message: 'Please input a valid Link.',
              },
            }}
          />
          <ErrorMessage
            errors={errors}
            name={`data.related_link`}
            render={({ message }) => {
              return <div className={styles.errorMessage}>{message}</div>;
            }}
          />
        </div>
      ) : null}
      <div className={styles.formItem}>
        <div className={styles.labelContainer}>
          <div className={styles.label}>Interaction description</div>
        </div>
        <Controller
          control={control}
          name="data.desc"
          render={({ field, fieldState }) => (
            <AutoSizeTextarea
              className={styles.input}
              placeholder="Describe how to interact... "
              value={field?.value}
              onChange={field?.onChange}
              minHeight={20}
              maxHeight={160}
              showLength
              maxLength={200}
              error={!!fieldState.error}
              rows={1}
            />
          )}
          rules={{
            required: true,
          }}
        />
      </div>
    </>
  );
};
